<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-grid" *ngIf="!isloader">
    <div class="vehicle-profile-header position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
        </div>
        <div class="overflow position-relative">
            <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="lifecycleList?.length">
                <div [ngClass]="state==='init'?'avilable-timeline':'xyz'"
                    *ngFor="let timeLine of lifecycleList; let i = index">
                    <div class="classy-timeline ">
                        <div style="--dot-color-var:{{timeLine?.color}};" class="timeline-decorator d-flex"
                            [ngClass]="{'visibility': i % 2 !== 0}">
                            <div class="timeline-content">
                                <div class="classy-timeline-subject" [ngClass]="{'dot-opacity': !timeLine?.action}">
                                    {{timeLine?.action?.length? (timeLine?.name |
                                    titlecase) : '.'}}</div>
                                <div class="d-flex min-width-90 align-data-end">
                                    <div class="story-location pr-2"></div>
                                    <div class="happening-time pl-2 tagged-date" *ngIf="timeLine?.action === 'tag'"
                                        [ngClass]="{'dot-opacity': !timeLine?.at}">
                                        {{timeLine?.at?.length? (timeLine?.at | date:'dd/MM/YY hh:mm:ss aaa'): '.'}}
                                    </div>
                                    <div class="happening-time pl-2" *ngIf="timeLine?.action !== 'tag'"
                                        [ngClass]="{'dot-opacity': !timeLine?.at}">
                                        {{timeLine?.at?.length? (timeLine?.at | date:'hh:mm:ss aaa':'en-US'): '.'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="--dot-color-var:{{timeLine?.color}};" class="timeline-decorator-before d-flex "
                            [ngClass]="{'visibility': i % 2 === 0}">
                            <div class="timeline-content-before">
                                <div class="classy-timeline-subject" [ngClass]="{'dot-opacity': !timeLine?.action}">
                                    {{timeLine?.action?.length? (timeLine?.name |
                                    titlecase) : '.'}}</div>
                                <div class="d-flex min-width-90 align-data-start">
                                    <div class="story-location"></div>
                                    <div class="happening-time tagged-date" *ngIf="timeLine?.action === 'tag'"
                                        [ngClass]="{'dot-opacity': !timeLine?.at}">
                                        {{timeLine?.at?.length? (timeLine?.at | date:'dd/MM/YY hh:mm:ss aaa'): '.'}}
                                    </div>
                                    <div class="happening-time" *ngIf="timeLine?.action !== 'tag'"
                                        [ngClass]="{'dot-opacity': !timeLine?.at}">
                                        {{timeLine?.at?.length? (timeLine?.at | date:'hh:mm:ss aaa':'en-US'): '.'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data-align" *ngIf="isError">
        No Data Available
    </div>
</div>